import React from "react";
import { NavLink } from "react-router-dom";
import {
  pathNewsSubAll,
  pathNewsSubImportant,
  pathNewsSubPinned,
} from "../../../common/config/vars";

interface INewsTypeList {
  setShowCount: React.Dispatch<React.SetStateAction<number>>;
}

export const NewsTypeList = ({ setShowCount }: INewsTypeList) => {
  return (
    <nav className="news_type_list" onClick={() => setShowCount(5)}>
      <NavLink
        exact
        to={pathNewsSubImportant}
        className="news_type_list_link"
        activeClassName="news_type_list_link_active"
      >
        Важные
      </NavLink>
      <NavLink
        exact
        to={pathNewsSubAll}
        className="news_type_list_link"
        activeClassName="news_type_list_link_active"
      >
        Все новости
      </NavLink>
      <NavLink
        exact
        to={pathNewsSubPinned}
        className="news_type_list_link"
        activeClassName="news_type_list_link_active"
      >
        Закрепленные
      </NavLink>
    </nav>
  );
};
